import { IApplicationState } from '../../types/redux';

export const selectFooterLayout = (state: IApplicationState) => state.footerLayout;
